// ------------------------------------
// Completa Endereço
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const urlApi = urlBase + 'core/acoes/shipping/completa_endereco.php';

  $('.compl-cep').each(function () {
    // Variáveis
    const $cep = $(this);
    const $cepLoader = $cep.closest('.form-input-loader');
    const $inputWrapper = $($cep.data('wrp'));
    const $cepInfos = $($cep.data('cep-infos'));
    const $logradouro = $($cep.data('logradouro'));
    const $numero = $($cep.data('numero'));
    const $bairro = $($cep.data('bairro'));
    const $cidade = $($cep.data('cidade'));
    const $cidadeWrp = $cidade.closest('.city-wrp');
    const $estado = $($cep.data('estado'));
    const $estadoWrp = $estado.closest('.state-wrp');
    const $allAddressInput = $('[class*="compl-"]');
    let address = {};
    let loadedAddress = $cep.data('address');

    // Exibe o endereço já salvo no checkout
    if (loadedAddress && Object.keys(loadedAddress).length > 0) {
      if ($cepInfos.length && $cidade.val() && $estado.val()) {
        $cidadeWrp.hide();
        $estadoWrp.hide();
        $cepInfos.text($cidade.val() + ' / ' + $estado.val());
        $cepInfos.show();
      } else if ($cepInfos.length && (!loadedAddress?.city || !loadedAddress?.state)) {
        $cidadeWrp.show();
        $estadoWrp.show();
      }
      $inputWrapper.slideDown(function () {
        if ($cep.attr('id') === 'co-zipcode') {
          if (checkoutStepsEnable) {
            if ($('.co-address-wrp').hasClass('current')) {
              $('.co-address-wrp .checkout-nav').show();
            }
            $('.co-shipping-ways').slideDown();
          } else {
            $('.co-shipping-ways').slideDown();
          }
        }
        if (
          checkoutStepsEnable &&
          $cep.attr('id') === 'co-zipcode-billing' &&
          $('.co-address-wrp').hasClass('current')
        ) {
          $('.co-address-wrp .checkout-nav').show();
        }
      });
    }

    // Executa a ação quando o CEP é alterado
    $cep.on('input', function () {
      handleAddress();
    });
    function handleAddress() {
      const cepLength = $cep.val().replace(/\D/g, '').length;
      if (cepLength >= 8) {
        getAddress();
      } else {
        $inputWrapper.hide();
        if ($cepInfos.length) {
          $cepInfos.text('');
          $cepInfos.hide();
        }
        if ($cep.attr('id') === 'co-zipcode') {
          if (checkoutStepsEnable) {
            if ($('.co-address-wrp').hasClass('current')) {
              $('.co-shipping-ways').slideUp();
              $('.co-address-wrp .checkout-nav').hide();
            }
          } else {
            $('.co-shipping-ways').slideUp();
          }
        }
        if (
          checkoutStepsEnable &&
          $cep.attr('id') === 'co-zipcode-billing' &&
          $('.co-address-wrp').hasClass('current')
        ) {
          $('.co-address-wrp .checkout-nav').hide();
        }
      }
    }

    // Obtém o endereço completo
    function getAddress() {
      $cep.parsley().removeError('ezdz-error', { updateClass: true });
      processingAddress();
      // Realiza a requisição dos dados
      $.getJSON(`${urlApi}?cep=${$cep.val()}&slug=${baseStore}`, function (result) {
        console.log(result);
        finishedAddress();
        if (result.cidade) {
          address = result;
        } else {
          console.log('CEP não encontrado.');
          address = {};
        }
        populateAddress();
      }).fail(errorAddress);
    }

    // Popula os campos do endereço
    function populateAddress() {
      $cep.parsley().validate();
      $logradouro.val(address?.logradouro || '').trigger('change');
      $bairro.val(address?.bairro || '').trigger('change');
      $cidade.val(address?.cidade || '').trigger('change');
      $estado.val(address?.uf || '').trigger('change');
      if (address.cidade) {
        $logradouro.trigger('change');
        $bairro.trigger('change');
        $cidade.trigger('change');
        $estado.trigger('change');
        $logradouro.parsley().validate();
        $bairro.parsley().validate();
        $cidade.parsley().validate();
        $estado.parsley().validate();
        if ($cepInfos.length) {
          $cidadeWrp.hide();
          $estadoWrp.hide();
          $cepInfos.text(address.cidade + ' / ' + address.uf);
          $cepInfos.show();
        }
      } else {
        $cidadeWrp.show();
        $estadoWrp.show();
      }
      $inputWrapper.slideDown(function () {
        if (address.cidade && !$numero.val()) {
          $numero.focus();
        }
      });
      if ($cep.attr('id') === 'co-zipcode') {
        $('.shipping_ways').trigger('change-cart');
        if (checkoutStepsEnable) {
          if ($('.co-address-wrp').hasClass('current')) {
            $('.co-address-wrp .checkout-nav').show();
          }
          $('.co-shipping-ways').slideDown();
        } else {
          if ($('input[name="payment_method"]:checked').val()) {
            dispatchPaymentInfo();
          }
          $('.co-shipping-ways').slideDown();
        }
      }
      if (checkoutStepsEnable && $cep.attr('id') === 'co-zipcode-billing' && $('.co-address-wrp').hasClass('current')) {
        $('.co-address-wrp .checkout-nav').show();
      }
    }

    // Ações executadas enquanto a requisição é processada
    function processingAddress() {
      $cepLoader.addClass('active');
      if ($cepInfos.length) {
        $cepInfos.text('');
        $cepInfos.hide();
      }
      $allAddressInput.each(function () {
        $(this).parsley().reset();
      });
    }

    // Ações executadas quanto a requisição é finalizada
    function finishedAddress() {
      $cepLoader.removeClass('active');
    }

    // Erro na requisição do endereço
    function errorAddress(resp) {
      console.log(resp);
      finishedAddress();
      populateAddress();
    }
  });
})();

// ------------------------------------
// Exibe/Oculta endereço de cobrança
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const $mesmoEndereco = $('#co-same-billing-address');
  const $enderecoCobranca = $('.co-billing');
  const $enderecoCobrancaCampos = $enderecoCobranca.find('.form-input[data-required]');
  if ($mesmoEndereco.length > 0) {
    // Evento ao alterar
    $mesmoEndereco.on('change', handleEnderecoCobranca);
    handleEnderecoCobranca();
    function handleEnderecoCobranca() {
      if ($mesmoEndereco.is(':checked')) {
        $enderecoCobranca.slideUp();
        $enderecoCobrancaCampos.prop('disabled', true);
        $enderecoCobrancaCampos.prop('required', false);
      } else {
        $enderecoCobranca.slideDown();
        $enderecoCobrancaCampos.prop('disabled', false);
        $enderecoCobrancaCampos.prop('required', true);
      }
      $enderecoCobrancaCampos.each(function () {
        $(this).parsley().reset();
      });
    }
  }
})();

// ------------------------------------
// Formas de envio
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  /*  
  const $shippingDescInput = $('#shipping-desc');
  const $shippingValInput = $('#shipping-val'); */
  const $shippingWays = $('.shipping_ways');
  const $laoder = $('.shipping-ways-loader');
  const $zipcode = $('#co-zipcode');
  const shippingMethod = $zipcode.data('shipping-method');
  const urlApi = urlBase + 'core/acoes/shipping/formas_entrega.php';
  let zipcode;
  let shipping_ways;
  let reqAjax = null;

  // Ao selecionar um forma de envio
  $shippingWays.on('change trigger-ship', 'input', handleChangeShippingWays);
  function handleChangeShippingWays() {
    const $shippingWay = $('.shipping_ways input:checked');
    const shippingWay = $shippingWay.val();
    const title = $shippingWay.data('desc');
    const price = $shippingWay.data('price');
    saveOption('shipping_way', shippingWay);
    saveOption('shipping_way_title', title);
    saveOption('shipping_way_price', price);
    if (shippingWay && shippingWay != $shippingWays.data('value')) {
      $shippingWays.data('value', shippingWay);
      console.log('Save from: shipping change');
      saveCheckout('save', {}, calcCheckout);
    } else {
      calcCheckout();
    }
    if ($('#sec-step-infos-ship').length > 0) {
      let shipText = title;
      let prazo = $shippingWay.parent().find('small').text();
      if (prazo != '') {
        shipText += ' - ' + prazo;
      }
      if (price > 0) {
        shipText += ' - R$ ' + formatMoneyBR(price);
      }
      $('#sec-step-infos-ship').text(shipText).trigger('sec-step-infos-ship-change');
    }
  }

  // Reseta a forma de envio
  function resetShippingWays() {
    $shippingWays.data('value', '');
    saveOption('shipping_way', '');
    saveOption('shipping_way_title', '');
    saveOption('shipping_way_price', '');
    //saveCheckout('save', {}, calcCheckout);
    calcCheckout();
  }

  // Ao alterar o cep de destino
  //$zipcode.on('change change-coupon change-orderbump change-quantity', handleShippingWays);
  //$zipcode.on('change change-coupon change-orderbump', handleShippingWays);
  $shippingWays.on('change-cart', handleShippingWays);
  if ($zipcode.val() != '') {
    handleShippingWays();
  }
  function handleShippingWays() {
    if ($shippingWays.length > 0) {
      zipcode = $zipcode.val();
      if (zipcode != '' && zipcode.length >= 8) {
        getShippingWays();
      } else {
        resetShippingWays();
      }
    }
  }

  // Obtém as formas de entrega
  function getShippingWays() {
    processingSW();
    const dataShip = $shippingWays.data('infos') || {};
    dataShip['store_token'] = storeToken;
    dataShip['store_id'] = baseLanding;
    dataShip['cart_token'] = cartToken;
    dataShip['zipcode'] = zipcode;
    dataShip['address'] = $('#co-address').val();
    dataShip['number'] = $('#co-number').val();
    dataShip['neighborhood'] = $('#co-neighborhood').val();
    dataShip['city'] = $('#co-city').val();
    dataShip['uf'] = $('#co-state').val();
    dataShip['save'] = '1';
    // Realiza a requisição dos dados
    $.getJSON(urlApi, dataShip, function (result) {
      console.log(result);
      if (result.status == 'success') {
        shipping_ways = result.shipping_ways;
        shipping_ways.forEach((way, index) => {
          way.old_price = way.price;
        });
        populateShippingWays();
      } else {
        errorSW(result);
      }
    }).fail('errorSW');
  }

  // Popula as formas de envio
  function populateShippingWays() {
    $shippingWays.html('').show();
    const hasSavedItem = $shippingWays.data('value') != '' || getOption('shipping_way');
    const savedValue = $shippingWays.data('value') || getOption('shipping_way');
    const matchFound = hasSavedItem
      ? shipping_ways.some((way) => way.shipping_way === savedValue)
      : false;
    if (hasSavedItem && !matchFound) {
      // A forma de envio previamente selecionada não veio nesta nova cotação 
      console.warn('shipping_way - previous selection "' + savedValue + '" not found in new quote, keeping unchecked');
    }
    shipping_ways.forEach((way, index) => {
      let checked = '';
      if (hasSavedItem && matchFound) {
        if ($shippingWays.data('value') && $shippingWays.data('value') === way.shipping_way) {
          console.log('shipping_way - checked by data-value: ' + $shippingWays.data('value'));
          checked = 'checked';
        } else if (getOption('shipping_way') && getOption('shipping_way') === way.shipping_way) {
          console.log('shipping_way - checked by option: ' + getOption('shipping_way'));
          checked = 'checked';
        }
      } else if (!hasSavedItem && index === 0) {
        console.log('shipping_way - checked by first item');
        checked = 'checked';
      }
      if (getOption('free_shipping') == 1) {
        way.price = 0;
      } else {
        way.price = way.old_price;
      }
      const priceView = Number(way.price) > 0 ? 'R$ ' + formatMoneyBR(Number(way.price)) : 'Grátis';
      const priceClass = Number(way.price) > 0 ? '' : 'd-none';
      $shippingWays.append(`
      <div class="form-check shipping_way">
        <input type="radio" name="shipping_way" id="co_shipping_way_${way.shipping_way}" value="${way.shipping_way}" data-desc="${way.title}" data-price="${way.price}" required ${checked}>
        <label for="co_shipping_way_${way.shipping_way}">
          <div class="shipping_way_infos">
            <b>${way.title}</b>
            <small>${way.text}</small>
          </div>
          <div class="shipping_way_price ${priceClass}">${priceView}</div>
        </label>
      </div>`);
    });
    finishedSW();
    $('body').trigger('shipping-ways-show');
    //$('.shipping_ways input:checked').trigger('trigger-ship');
  }

  // Ações executadas enquanto a requisição é processada
  function processingSW() {
    $shippingWays.html('').hide();
    $laoder.show();
    if ($('#sec-step-infos-ship').length > 0) {
      $('#sec-step-infos-ship').text('...');
    }
  }

  // Ações executadas quanto a requisição é finalizada
  function finishedSW() {
    $laoder.hide();
    handleChangeShippingWays();
  }

  // Erro na requisição
  function errorSW(resp) {
    finishedSW();
    console.log(resp);
  }
})();
